module.exports = __webpack_public_path__ + "img/copy-page-reverse.5347eb3f.svg";